
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompleteGhgSavingPotential"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GhgSavingPotentialType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"needFulfilled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baselineSolutionDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comparativeUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comparativeQuantitiy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comparativeUnitConfirmed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"describeComparison"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPreciseEmissionCalculation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"simpleBaselineGhg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"simpleSolutionGhg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"simpleGhgJustification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emissionsConfirmed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"growthFactorJustification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isRecurringImpact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"durationOfImpact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"realisticConfirmation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impactProfileKind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isScenarioA"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preComputedBaselineGhg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preComputedSolutionGhg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scenarioBComments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emissionSourceLimitations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emissionSources"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompleteEmissionSource"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"specificReductionPerUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"specificReductionAsPercentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metricAssignments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompleteMetricAssignment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":798}};
    doc.loc.source = {"body":"#import \"./CompleteEmissionSource.gql\"\n#import \"./CompleteMetricAssignment.gql\"\n\nfragment CompleteGhgSavingPotential on GhgSavingPotentialType {\n  id\n  needFulfilled\n  baselineSolutionDescription\n  comparativeUnit\n  comparativeQuantitiy\n  comparativeUnitConfirmed\n  describeComparison\n  isPreciseEmissionCalculation\n  simpleBaselineGhg\n  simpleSolutionGhg\n  simpleGhgJustification\n  emissionsConfirmed\n  growthFactorJustification\n  isRecurringImpact\n  durationOfImpact\n  realisticConfirmation\n  impactProfileKind\n  isScenarioA\n  preComputedBaselineGhg\n  preComputedSolutionGhg\n  scenarioBComments\n  emissionSourceLimitations\n  emissionSources {\n    ...CompleteEmissionSource\n  }\n  specificReductionPerUnit\n  specificReductionAsPercentage\n  metricAssignments {\n    ...CompleteMetricAssignment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./CompleteEmissionSource.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./CompleteMetricAssignment.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CompleteGhgSavingPotential"] = oneQuery(doc, "CompleteGhgSavingPotential");
        
